import React, { PureComponent } from "react";

export default class EdgeView extends PureComponent<any, any> {        

    constructor(props: any){
        super(props);
        this.state = { 
            source: this.props.source,
            target: this.props.target,
            model: this.props.model,            
        };

        
    }

    render() {        
        const source = this.state.source;
        const target = this.state.target;    
        const id = "edge-" + source.getId() + "-" + target.getId(); 

        const className = this.props.new ? 'edge' : 'edge mount pale'

        if (this.props.new) {
            setTimeout(() => {
                const e = document.getElementById(id);
                if (e) {
                    e.setAttribute('class', 'edge mount');

                    setTimeout(() => {
                        e.setAttribute('class', 'edge mount pale')
                    }, 2000);
                }
            });
        }

        return <line className={className} id={id} x1={source.currentX()} y1={source.currentY()} x2={target.currentX()} y2={target.currentY()} />
    }
}
